module.exports = __webpack_public_path__ + "img/icon_guanyuwomen_lianghua@3x.85b51cd3.png";